export interface IErrorEventArgs {
    ErrorCode: string;
    ErrorMessage: string;
    FriendlyErrorTitle: string;
    FriendlyErrorMessage: string;
}

export class ErrorEventArgs implements IErrorEventArgs {
    public ErrorCode: string;
    public ErrorMessage: string;
    public FriendlyErrorTitle: string;
    public FriendlyErrorMessage: string;

    constructor(errorCode: string = '', errorMessage: string = '', friendlyErrorMessage: string = '', friendlyErrorTitle: string = 'Error') {
        this.Set(errorCode, errorMessage, friendlyErrorTitle, friendlyErrorMessage);
    }

    public Set(errorCode: string, errorMessage: string, friendlyErrorTitle: string, friendlyErrorMessage: string) {
        this.ErrorCode = errorCode;
        this.ErrorMessage = errorMessage;
        this.FriendlyErrorTitle = friendlyErrorTitle;
        this.FriendlyErrorMessage = friendlyErrorMessage;
    }

}
